import { render, staticRenderFns } from "./FlatGuestBox.vue?vue&type=template&id=59c35354&scoped=true&"
import script from "./FlatGuestBox.vue?vue&type=script&lang=js&"
export * from "./FlatGuestBox.vue?vue&type=script&lang=js&"
import style0 from "./FlatGuestBox.vue?vue&type=style&index=0&id=59c35354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c35354",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59c35354')) {
      api.createRecord('59c35354', component.options)
    } else {
      api.reload('59c35354', component.options)
    }
    module.hot.accept("./FlatGuestBox.vue?vue&type=template&id=59c35354&scoped=true&", function () {
      api.rerender('59c35354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2My6bZ5o4m28f/JS/comp/FlatGuestBox.vue"
export default component.exports